import React  from "react";
import moment from "moment";
import Translation from "../../../../commons/i18n/Translation";
import { RandomGradient } from "../../../../commons/index";
import LazyLoad from 'react-lazyload';
import { CommonsConstants } from "../../../../commons/index";
import Svg from "../../../../../svg/Svg";

class PostPresenter extends React.Component {

    renderPublisher = () => {
        if(this.props.post.publisher.isGroup)
            return this.renderGroup();

        return <a href={this.props.post.publisher.publicPermalink}>
            {( this.props.post.publisher.avatarUrl ?
                <span><img className="mywort-avatar mywort-avatar--small" src={this.props.post.publisher.avatarUrl} alt={this.props.post.publisher.fullName}/>&nbsp;</span>
                : null )}
            {this.props.post.publisher.fullName}
        </a>
    };

    renderGroup = () => (
        <a href={this.props.post.publisher.publicPermalink}>
            <Svg id="fa-users" className="u-text-mywort mywort-post__meta__publisher-group__svg"/> {this.props.post.publisher.fullName}
        </a>
    );

    svgMarkup(postType) {
        const mywortSvgWatermark = '<svg class="watermark watermark--'+ postType + '"><use xlink:href="#watermark-' + postType + '"></use></svg>';
        return {__html: mywortSvgWatermark};
    }

    renderImage = () => {
        if(this.props.post.mwTeaserMedium){
            return <figure className="mywort-teaser__picture mywort-teaser__section">
                    <a href={this.props.post.permaLink}>
                        {this.props.post.style? <div dangerouslySetInnerHTML={this.svgMarkup(this.props.post.style)}/>:null}
                        <LazyLoad height={95} once={true} offset={250} debounce={150} placeholder={<RandomGradient />}>
                            <img src={this.props.post.mwTeaserMedium} alt={this.props.post.title} style={{height:"95px"}}/>
                        </LazyLoad>
                    </a>
            </figure>
        } else {
            return <figure className="mywort-teaser__picture mywort-teaser__section">
                <a href={this.props.post.permaLink}>
                    <RandomGradient/>
                </a>
            </figure>
        }
    };

    renderMoreDatesCounter = () => {
        if(this.props.post.futureOccurrences.length > 5){
            let moreDateCount = "+"+(this.props.post.futureOccurrences.length - 5) + " "+Translation.translate("public.more");
            return <span className="date__item date__item--more">{moreDateCount}</span>
        }
    };

    renderEventDates = () => {
        let i = 0;
        let formattedDate;
        if(this.props.post.futureOccurrences && this.props.post.futureOccurrences.length > 0) {
            return  <div className="date__container__search date__container__small">
                <a href={this.props.post.permaLink}>
                    {this.props.post.futureOccurrences.map(function(date) {
                        formattedDate = moment(date).format('MMM')+" "+moment(date).format('D');
                        i++;
                        if(i < 6){
                            return <span key={date} className="date__item date__item--future">{ formattedDate }</span>
                        }
                    })} { this.renderMoreDatesCounter() }
                </a>
            </div>
        } else {
            return true;
        }
    };

    render = () => (
        <article className="mywort-teaser">
            { this.renderImage() }
            <div className="mywort-teaser__section u-full-width">
                <div className="mywort-teaser__overtitle">
                    <a href={this.props.post.localityPermalink}>{this.props.post.locality.name}</a>
                </div>
                { this.renderEventDates() }
                <a className="color-hover-edition" href={this.props.post.permaLink}>
                    <h3 className="mywort-teaser__title">{this.props.post.title}</h3>
                </a>
                <div className="mywort-teaser__meta">
                    { this.renderPublisher() }, {Translation.translate("public.published-at")} { moment(this.props.post.publishedAt).format(CommonsConstants.SIMPLE_DATE_WITH_HOUR_DISPLAY_FORMAT[Translation.getLanguageName()]) }
                </div>
            </div>
        </article>
    );
}


export default class SearchPostList extends React.Component {

    renderLoading = () => (
        <div className="u-text-center u-m-v">
            <h6 className="mywort-heading">
                {Translation.translate("search.loading")}
            </h6>
        </div>
    );

    renderEmptyResults = () => (
        <div className="u-text-center u-m-v">
            <h6 className="mywort-heading">{Translation.translate("search.noresults")}</h6>
            <div className="u-m-v">
                <button className="mywort-btn mywort-btn" onClick={this.props.onResetFilters}>
                    {Translation.translate("search.filters.reset")}
                </button>
            </div>
        </div>
    );

    render = () => {
        if(this.props.loading){
            return this.renderLoading();
        }
        if(this.props.results.length < 1){
            return this.renderEmptyResults();
        }
        return <div>
            {this.props.results.map( (post, idx) => <PostPresenter post={post} key={idx}/> )}
        </div>
    }
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/common/SearchPostList.jsx